(function() {
  if (window.clesanaUseCaseSliderScriptLoaded) {
    return;
  }

  window.clesanaUseCaseSliderScriptLoaded = true;

  var instances = window.clesanaUseCaseSliders = window.clesanaUseCaseSliders || {};
  var mobileQuery = window.matchMedia('(max-width: 768px)');

  function getSection(root) {
    if (!root) return null;

    if (root.matches && root.matches('[data-use-case-section]')) {
      return root;
    }

    return root.querySelector('[data-use-case-section]');
  }

  function getSectionId(section) {
    return section && section.getAttribute('data-section-id');
  }

  function destroy(section) {
    var sectionId = getSectionId(section);

    if (!sectionId || !instances[sectionId]) {
      return;
    }

    if (typeof instances[sectionId].destroy === 'function') {
      instances[sectionId].destroy();
    }

    delete instances[sectionId];
  }

  function initSection(section, attempts) {
    var sectionId = getSectionId(section);
    var track;
    var viewport;
    var cards;
    var controls;
    var dotsWrap;
    var prev;
    var next;
    var slider = null;
    var dots = [];
    var page = 0;
    var pageCount = 1;
    var wasSliderActive = false;
    var wasMobileLayout = mobileQuery.matches;
    var resizeTimer;

    attempts = attempts || 0;

    if (!sectionId) {
      return;
    }

    if (!window.theme || !theme.Slideshow) {
      if (attempts < 30) {
        window.setTimeout(function() {
          initSection(section, attempts + 1);
        }, 100);
      }

      return;
    }

    destroy(section);

    track = section.querySelector('[data-use-case-track]');
    viewport = section.querySelector('[data-use-case-viewport]');
    cards = Array.prototype.slice.call(section.querySelectorAll('[data-use-case-card]'));
    controls = section.querySelector('[data-use-case-controls]');
    dotsWrap = section.querySelector('[data-use-case-dots]');
    prev = section.querySelector('[data-use-case-prev]');
    next = section.querySelector('[data-use-case-next]');

    if (!track || !viewport || cards.length < 2 || !controls || !dotsWrap || !prev || !next) {
      return;
    }

    function isMobile() {
      return mobileQuery.matches;
    }

    function getTrackGap() {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || styles.gridColumnGap || 0);
      return isNaN(gap) ? 0 : gap;
    }

    function getRequiredWidth() {
      var cardWidth = cards[0].getBoundingClientRect().width;
      var gap = getTrackGap();
      return (cards.length * cardWidth) + ((cards.length - 1) * gap);
    }

    function needsSlider() {
      if (cards.length > 5) {
        return true;
      }

      return viewport.clientWidth + 1 < getRequiredWidth();
    }

    function updateDots() {
      dots.forEach(function(dot, index) {
        var selected = index === page;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-current', selected ? 'true' : 'false');
      });

      prev.disabled = page === 0;
      next.disabled = page === pageCount - 1;
    }

    function goTo(targetPage) {
      if (!slider) {
        return;
      }

      page = Math.max(0, Math.min(targetPage, pageCount - 1));
      slider.goToSlide(page);
      updateDots();
    }

    function buildDots() {
      pageCount = slider && slider.slideshow ? slider.slideshow.slides.length : 1;
      page = slider && slider.slideshow ? slider.slideshow.selectedIndex : 0;
      dotsWrap.innerHTML = '';
      dots = [];

      for (var index = 0; index < pageCount; index += 1) {
        (function(dotIndex) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'use-case-slider__dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (dotIndex + 1));
          dot.addEventListener('click', function() {
            goTo(dotIndex);
          });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        })(index);
      }

      controls.hidden = !isMobile() || pageCount <= 1;
      updateDots();
    }

    function createSlider() {
      var sliderActive = needsSlider();

      if (slider) {
        slider.destroy();
        slider = null;
      }

      dotsWrap.innerHTML = '';
      controls.hidden = true;
      wasSliderActive = sliderActive;
      wasMobileLayout = isMobile();

      if (!sliderActive) {
        return;
      }

      slider = new theme.Slideshow(track, {
        accessibility: true,
        cellAlign: 'left',
        contain: !isMobile(),
        draggable: true,
        dragThreshold: 5,
        friction: 0.8,
        groupCells: false,
        initialIndex: 0,
        pageDots: false,
        percentPosition: false,
        prevNextButtons: false,
        resize: true,
        rightToLeft: Boolean(window.theme && window.theme.config && window.theme.config.rtl),
        selectedAttraction: 0.14,
        setGallerySize: true,
        wrapAround: true
      });

      slider.slideshow.on('change', function(index) {
        page = index;
        updateDots();
      });

      slider.slideshow.on('dragStart', function() {
        track.classList.add('is-dragging');
      });

      slider.slideshow.on('dragEnd', function() {
        track.classList.remove('is-dragging');
      });

      buildDots();
    }

    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function() {
        var sliderActive = needsSlider();
        var mobileLayout = isMobile();

        if (wasSliderActive !== sliderActive || wasMobileLayout !== mobileLayout) {
          createSlider();
        } else if (slider) {
          slider.resize();
        }
      }, 150);
    }

    function onBlockSelect(event) {
      if (!event.detail || !event.detail.blockId || !slider) {
        return;
      }

      var cardIndex = cards.findIndex(function(card) {
        return card.dataset.blockId === event.detail.blockId;
      });

      if (cardIndex >= 0) {
        slider.goToSlide(cardIndex);
      }
    }

    function onPrev() {
      goTo(page - 1);
    }

    function onNext() {
      goTo(page + 1);
    }

    prev.addEventListener('click', onPrev);
    next.addEventListener('click', onNext);
    window.addEventListener('resize', onResize);
    document.addEventListener('shopify:block:select', onBlockSelect);

    createSlider();

    instances[sectionId] = {
      destroy: function() {
        prev.removeEventListener('click', onPrev);
        next.removeEventListener('click', onNext);
        window.removeEventListener('resize', onResize);
        document.removeEventListener('shopify:block:select', onBlockSelect);
        window.clearTimeout(resizeTimer);

        if (slider) {
          slider.destroy();
        }
      }
    };
  }

  function initAll(root) {
    var section = getSection(root);

    if (section) {
      initSection(section);
      return;
    }

    (root || document).querySelectorAll('[data-use-case-section]').forEach(function(section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var section = getSection(event.target);

    if (section) {
      destroy(section);
    }
  });
})();
